<div class="content">
  <div class="messagesWrapper">
    @for (message of messages; track message) {
      <div>
        {{ message }}
      </div>
    }
  </div>
  <div class="dialogButtons">
    <span class="spacer"></span>
    <button class="primary-button" matButton="elevated" (click)="close()">Close</button>
  </div>
</div>
